(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function initSection(root) {
      if (root.dataset.cstInit === '1') return;
      root.dataset.cstInit = '1';
      var tabs = root.querySelectorAll('[data-cst-tab]');
      var panels = root.querySelectorAll('[data-cst-panel]');
      var intros = root.querySelectorAll('[data-cst-intro]');
      tabs.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('cross-sell-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.add('cross-sell-tabs__panel--hidden');
          });
          intros.forEach(function (el) {
            el.classList.add('cross-sell-tabs__intro--hidden');
          });
          btn.classList.add('cross-sell-tabs__tab--active');
          btn.setAttribute('aria-selected', 'true');
          if (panels[idx]) {
            panels[idx].classList.remove('cross-sell-tabs__panel--hidden');
          }
          if (intros[idx]) {
            intros[idx].classList.remove('cross-sell-tabs__intro--hidden');
          }
          /* Skrytý panel má nulovou šířku, takže si rf-carousel.js myslí,
             že není kam posouvat, a šipky schová. Po přepnutí záložky je
             potřeba přepočítat — skript to dělá při změně velikosti okna. */
          window.dispatchEvent(new Event('resize'));
        });
      });
      root.querySelectorAll('[data-cst-variant-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          /* Vlastní volbu zákazníka si pamatujeme, ať ji předvyplnění
             podle velikosti bot znovu nepřepíše. Příznak se nastavuje
             u každé změny, která nepřišla od nás — `isTrusted` se na to
             nedá použít, ten je false i u změn z jiných skriptů. */
          if (!programoveNastaveni) sel.dataset.cstRucne = '1';
          var form = sel.closest('form');
          if (!form) return;
          var hidden = form.querySelector('[data-cst-variant-input]');
          var submit = form.querySelector('button[name="add"]');
          var picked = sel.selectedOptions && sel.selectedOptions[0];
          var available = picked && picked.getAttribute('data-available') !== 'false';
          /* Vyprodaná velikost se smí ukázat (předvyplňujeme ji, aby bylo
             vidět proč to nejde koupit), ale do formuláře se nezapisuje. */
          if (hidden) hidden.value = (sel.value && available) ? sel.value : '';
          if (submit) submit.disabled = !(sel.value && available);
        });
      });

      doplnVelikost(root);
    }

    /* =========================================================
       Velikost z bot se propíše do nabídky doplňků
       Připomínka klienta (Oldřich, 9. 9. 2026): „nemusíte znát velikost
       svoji a nemáte ještě za sebou ten proces určování velikosti…
       vy chcete spíš poté, co si vyberete boty, dostat nabídku na
       dokoupení stélek ve velikosti, kterou jste si vybral."

       Jakmile si zákazník nahoře zvolí velikost boty, selecty u doplňků
       se samy nastaví na odpovídající velikost. Zůstávají přepínatelné —
       stélky se kupují i pro někoho jiného — a co si zákazník přepne
       sám, se už nepřepisuje.

       Párování podle textu volby:
         stélky   „42"      = přesná shoda, mají stejnou škálu 35–47
         ponožky  „36-41"   = rozsah, hledá se ten, do kterého velikost
                              spadá (pomlčka i spojovník)
       Když nic nesedí — třeba velikost 43 u ponožek se sadou
       36-38 / 39-42 / 44-46 — zůstane „Zvolte velikost".

       Vyprodaná velikost se předvyplní taky, jen s poznámkou „— Vyprodáno"
       a zablokovaným tlačítkem. Prázdný select totiž vypadá, jako by
       předvyplnění nefungovalo; takhle je vidět důvod. Do formuláře se
       zapíše jen velikost, která se dá koupit. Když sedí víc voleb
       (překrývající se rozsahy), vybere se přednostně dostupná.
       ========================================================= */
    function zvolenaVelikostBoty() {
      /* Bere se první zaškrtnutá volba, která vypadá jako velikost boty.
         Projít všechny je pojistka pro produkt s víc volbami (barva +
         velikost) — tam by první zaškrtnutá byla barva. Rozsah („35-46")
         se schválně nebere: na stránce ponožek je hlavní volbou právě on
         a u doplňků by nedával smysl. */
      var vstupy = document.querySelectorAll('.product-information .variant-option input:checked');
      for (var i = 0; i < vstupy.length; i++) {
        var hodnota = (vstupy[i].value || '').trim();
        if (/^\d{2}$/.test(hodnota)) return hodnota;
      }
      return null;
    }

    function textVolby(option) {
      /* U vyprodaných je za velikostí ještě „ — Vyprodáno" (v každém
         jazyce stejná pomlčka, přidává ji šablona výš). Dělí se na
         pomlčce s mezerami, ať se neutne rozsah zapsaný pomlčkou. */
      return (option.textContent || '').replace(/\s+/g, ' ').split(' \u2014 ')[0].trim();
    }

    function velikostSedi(text, velikost) {
      if (text === velikost) return true;
      var rozsah = text.match(/^(\d{2})\s*[-\u2013\u2014]\s*(\d{2})$/);
      if (!rozsah) return false;
      var n = parseInt(velikost, 10);
      return n >= parseInt(rozsah[1], 10) && n <= parseInt(rozsah[2], 10);
    }

    /* Zvednuté po dobu našeho vlastního zápisu do selectu, ať se změna
       nezapíše zákazníkovi jako ruční volba. */
    var programoveNastaveni = false;

    function doplnVelikost(root) {
      var velikost = zvolenaVelikostBoty();
      if (!velikost) return;
      root.querySelectorAll('[data-cst-variant-select]').forEach(function (sel) {
        if (sel.dataset.cstRucne === '1') return;
        var shoda = null;
        var nahradni = null;
        for (var i = 0; i < sel.options.length; i++) {
          var o = sel.options[i];
          if (!o.value) continue;
          if (!velikostSedi(textVolby(o), velikost)) continue;
          if (!o.disabled) {
            shoda = o;
            break;
          }
          if (!nahradni) nahradni = o;
        }
        shoda = shoda || nahradni;
        if (!shoda || sel.value === shoda.value) return;
        sel.value = shoda.value;
        /* Vlastní událost dopíše skryté `id` a odemkne tlačítko — stejnou
           cestou jako ruční výběr. */
        programoveNastaveni = true;
        try {
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          programoveNastaveni = false;
        }
      });
    }

    var naplanovano = false;
    function naplanujDoplneni() {
      if (naplanovano) return;
      naplanovano = true;
      /* Horizon po změně varianty překresluje obsah detailu; krátká
         prodleva počká, než se ustálí. */
      setTimeout(function () {
        naplanovano = false;
        document.querySelectorAll('.cross-sell-tabs').forEach(doplnVelikost);
      }, 120);
    }

    /* Výběr velikosti probíhá na skrytých radiích nativního pickeru —
       ať už klikne zákazník do našeho selectu, nebo přijde s ?variant=. */
    document.addEventListener('change', function (e) {
      var cil = e.target;
      if (cil && cil.closest && cil.closest('.variant-option')) naplanujDoplneni();
    });
    document.querySelectorAll('.cross-sell-tabs').forEach(initSection);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.cross-sell-tabs').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-featured-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function init(root) {
      if (root.dataset.rfFtInit === '1') return;
      root.dataset.rfFtInit = '1';

      // Tabs
      var tabs = root.querySelectorAll('[data-rf-tab]');
      var panels = root.querySelectorAll('[data-rf-panel]');
      tabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-rf-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('rf-ft__tab--active', t === btn);
            t.setAttribute('aria-selected', t === btn ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('rf-ft__panel--hidden', p.getAttribute('data-rf-panel') !== idx);
          });
        });
      });

      // Wishlist toggle (localStorage)
      var store;
      try { store = JSON.parse(localStorage.getItem('rf-wishlist') || '{}'); } catch (e) { store = {}; }
      root.querySelectorAll('[data-rf-wish]').forEach(function (btn) {
        var handle = btn.getAttribute('data-rf-wish');
        if (store[handle]) btn.classList.add('is-active');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var on = btn.classList.toggle('is-active');
          if (on) { store[handle] = 1; } else { delete store[handle]; }
          try { localStorage.setItem('rf-wishlist', JSON.stringify(store)); } catch (e2) {}
        });
      });

      // Circle scribble — Lottie, play while in view.
      var lot = root.querySelector('[data-rf-lottie]');
      if (lot) {
        (function initLottie() {
          if (!window.lottie) { setTimeout(initLottie, 120); return; }
          if (lot.dataset.rfLottieDone) return;
          lot.dataset.rfLottieDone = '1';
          var anim = window.lottie.loadAnimation({
            container: lot,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: lot.getAttribute('data-src'),
            rendererSettings: { preserveAspectRatio: 'none' }
          });
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (ents) {
              ents.forEach(function (e) { if (e.isIntersecting) { anim.play(); } else { anim.pause(); } });
            }, { threshold: 0.2 }).observe(lot);
          } else {
            anim.play();
          }
        })();
      }
    }
    document.querySelectorAll('[data-rf-ft]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-rf-ft]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
